import { useQuery } from '@tanstack/react-query';
import { financialApi } from '../api/financialApi';
import type { ReportType, ReportTimeRange } from '../types/report.types';

export const useFinancialReports = (
  type: ReportType,
  timeRange: ReportTimeRange,
) => {
  return useQuery({
    queryKey: ['financial-reports', type, timeRange],
    queryFn: () => financialApi.getFinancialReports({ type, timeRange }),
    enabled: !!type && !!timeRange, // Only fetch when both params are provided
  });
};
